import * as PIXI from "pixi.js";
import { GameAssets } from "src/shared/util/GameAssets";
import AppSingleton from "src/shared/util/AppSingleton";

export class IntroView extends PIXI.Container {
  private content: PIXI.Container;
  private loadingContent: PIXI.Container;

  private content1: PIXI.Container;
  private content3: PIXI.Container;
  private background: PIXI.Sprite;
  private logo: PIXI.Sprite;
  private plant1: PIXI.Sprite;
  private plant2: PIXI.Sprite;
  private tapText: PIXI.Text;
  private loadingMask: PIXI.Graphics;
  private loadingBarWidth: number;
  private onHandleKeyDown: (event: KeyboardEvent) => void;
  private app: PIXI.Application<PIXI.Renderer>;

  constructor() {
    super();

    this.app = AppSingleton.getInstance().app;
    this.app.stage.on("resize", this.resize, this);

    this.content = new PIXI.Container();
    this.addChild(this.content);

    this.loadingContent = new PIXI.Container();
    this.loadingContent.visible = true;
    this.logo = new PIXI.Sprite(
      GameAssets.loading.loadingAtlas.textures["gameLogo.png"],
    );
    this.logo.anchor.set(0.5);
    this.plant1 = new PIXI.Sprite(
      GameAssets.loading.loadingAtlas.textures["plant.png"],
    );
    this.plant2 = new PIXI.Sprite(
      GameAssets.loading.loadingAtlas.textures["plant.png"],
    );
    this.plant1.anchor.set(0.5);
    this.plant2.scale.set(-1, 1);
    this.plant2.anchor.set(0.5);

    this.background = new PIXI.Sprite(GameAssets.loading.introBg);
    this.background.anchor.set(0.5);

    const loadingBar = new PIXI.Sprite(
      GameAssets.loading.loadingAtlas.textures["introFillBar.png"],
    );
    loadingBar.anchor.set(0.5);
    loadingBar.y = 0;
    const loadingBarBg = new PIXI.Sprite(
      GameAssets.loading.loadingAtlas.textures["introFillBg.png"],
    );
    loadingBarBg.anchor.set(0.5);
    loadingBarBg.y = 0;

    // Create a mask (a rectangle that grows with progress)
    this.loadingMask = new PIXI.Graphics();
    this.loadingMask
      .rect(0, 0, loadingBar.width, loadingBar.height)
      .fill(0xffffff);
    this.loadingMask.x = loadingBar.x - loadingBar.width / 2;
    this.loadingMask.y = loadingBar.y - loadingBar.height / 2;
    this.loadingMask.width = 0;
    loadingBar.mask = this.loadingMask;
    // Set the max width for the loading bar
    this.loadingBarWidth = loadingBar.width;

    this.loadingContent.addChild(loadingBarBg);
    this.loadingContent.addChild(loadingBar);
    this.loadingContent.addChild(this.loadingMask);

    this.content1 = new PIXI.Container();
    this.content1.position.set(0, 50);

    const content1Text = new PIXI.Text({
      text: "All wilds are expanding!",
      style: {
        fontSize: 40,
        align: "center",
        wordWrap: true,
        wordWrapWidth: 600,
        fontFamily: "TextFont",
        fill: "0xfad035",
        stroke: { color: "0x4a1850", width: 4, join: "round" },
      },
    });

    const content1Texture = new PIXI.Sprite(
      GameAssets.loading.loadingAtlas.textures["content1.png"],
    );
    content1Texture.anchor.set(0.5);
    content1Texture.y = 20;

    content1Text.anchor.set(0.5);
    content1Text.position.set(0, 230);

    this.content1.addChild(content1Text);
    this.content1.addChild(content1Texture);

    const content3Text = new PIXI.Text({
      text: "Win Up To 1000x Your Bet!",
      style: {
        fontSize: 60,
        align: "center",
        wordWrap: false,
        fontFamily: "TextFont",
        fill: "0xfad035",
        stroke: { color: "0x4a1850", width: 4, join: "round" },
      },
    });
    content3Text.anchor.set(0.5);
    const content3RtpText = new PIXI.Text({
      text: "RTP: 96.12%",
      style: {
        fontSize: 40,
        align: "center",
        wordWrap: true,
        wordWrapWidth: 600,
        fontFamily: "TextFont",
        fill: "0xffffff",
        stroke: { color: "0x000", width: 4, join: "round" },
      },
    });

    content3RtpText.anchor.set(0.5);
    content3RtpText.position.set(0, 70);

    this.content3 = new PIXI.Container();
    this.content3.addChild(content3Text);
    this.content3.addChild(content3RtpText);

    this.tapText = new PIXI.Text({
      text: "Tap Anywhere to Continue",
      style: {
        fontSize: 40,
        align: "center",
        fontFamily: "TextFont",
        fill: "0xffffff",
        stroke: { color: "0x000000", width: 4, join: "round" },
      },
    });
    this.tapText.anchor.set(0.5);
    this.tapText.position.set(0, 450);
    this.tapText.visible = false;

    this.onHandleKeyDown = this.handleKeyDown.bind(this);

    this.content.addChild(this.background);
    this.content.addChild(this.logo);
    this.content.addChild(this.plant1);
    this.content.addChild(this.plant2);
    this.content.addChild(this.tapText);
    this.content.addChild(this.loadingContent);
    this.content.addChild(this.content1);
    this.content.addChild(this.content3);
  }

  private handleKeyDown(event: KeyboardEvent) {
    switch (event.code) {
      case "Space":
      case "Enter":
        this.onScreenClick();
        break;
    }
  }

  private onScreenClick() {
    this.off("pointerup", this.onScreenClick, this);
    window.removeEventListener("keyup", this.onHandleKeyDown);
    this.emit("onScreenClick");
  }

  public updateProgress(progress: number) {
    // Update the mask width based on the progress
    this.loadingMask.width = this.loadingBarWidth * progress; // Scale the width
  }

  public showTapText() {
    this.interactive = true;
    this.on("pointerup", this.onScreenClick, this);

    window.addEventListener("keyup", this.onHandleKeyDown);

    this.loadingContent.visible = false;
    this.tapText.visible = true;
  }

  private resize(data: any) {
    if (data.ratio < 1.4) {
      this.onPortrait();
    } else {
      this.onLandscape();
    }
  }

  private onPortrait() {
    this.background.scale.set(1.8);
    this.logo.scale.set(1.2);
    this.logo.position.set(0, -650);
    this.loadingContent.position.set(0, 800);
    this.tapText.position.set(0, 800);
    this.tapText.scale.set(1.5);

    this.plant1.position.set(-600, 800);
    this.plant2.position.set(650, 850);
    this.plant1.scale.set(2, 2);
    this.plant2.scale.set(-2, 2);

    this.content1.position.set(0, 100);
    this.content1.scale.set(1.5);
    this.content3.position.set(0, -300);
    this.content3.scale.set(0.9);
  }

  private onLandscape() {
    this.background.scale.set(1);
    this.logo.scale.set(0.8);
    this.logo.position.set(0, -400);
    this.loadingContent.position.set(0, 450);
    this.tapText.position.set(0, 450);
    this.tapText.scale.set(1);

    this.plant1.position.set(-650, 350);
    this.plant2.position.set(650, 350);
    
    this.plant1.scale.set(1, 1);
    this.plant2.scale.set(-1, 1);

    this.content1.position.set(0, 50);
    this.content1.scale.set(1);
    this.content3.position.set(0, -200);
    this.content3.scale.set(1);
  }
}
